import React from 'react';

import { ActionIcon, createStyles, Group, Menu, Title } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconDeviceIpadHorizontalCheck, IconPlus, IconSearch } from '@tabler/icons-react';
import { ReactComponent as KiloLogo } from 'assets/svg/long_kilo_blue_white.svg';
import { useNavigate } from 'react-router-dom';

import FiltersDrawer from './FiltersDrawer';
import { FilterTerms } from '../types';

interface IScheduleHeader {
  searchFilters: FilterTerms;
  initialSearchFiltersValue: FilterTerms;
  setSearchFilters: React.Dispatch<React.SetStateAction<FilterTerms>>;
  handleOpenCreateClassForm: () => void;
  handleOpenCreateAppointmentForm: () => void;
  permission?: boolean;
}

const useStyles = createStyles(theme => ({
  header: {
    width: '100%',
    background: theme.white,
    padding: theme.spacing.md,
    boxShadow: theme.shadows.xs,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: theme.spacing.lg,
    marginBottom: '2px',
  },
  end: {
    width: '50px',
  },
}));

const ScheduleHeader = ({
  searchFilters,
  initialSearchFiltersValue,
  setSearchFilters,
  handleOpenCreateClassForm,
  handleOpenCreateAppointmentForm,
  permission,
}: IScheduleHeader): JSX.Element => {
  const { classes } = useStyles();
  const navigate = useNavigate();

  const [isFilterDrawerOpen, filterDrawerHandlers] = useDisclosure(false);

  const redirectToKiosk = (): void => {
    navigate('/kiosk');
  };

  return (
    <div className={classes.header}>
      <Title order={3} color='gray.8' className={classes.end}>
        Schedule
      </Title>
      <Group spacing='lg'>
        <ActionIcon variant='light' color='kiloBlue' onClick={redirectToKiosk}>
          <IconDeviceIpadHorizontalCheck />
        </ActionIcon>
        <ActionIcon variant='light' color='kiloBlue' onClick={filterDrawerHandlers.open}>
          <IconSearch />
        </ActionIcon>
        <Menu withinPortal>
          <Menu.Target>
            <ActionIcon variant='filled' color='kiloBlue' disabled={!permission}>
              <IconPlus />
            </ActionIcon>
          </Menu.Target>
          <Menu.Dropdown>
            <Menu.Item onClick={handleOpenCreateClassForm}>Class</Menu.Item>
            <Menu.Item onClick={handleOpenCreateAppointmentForm}>Appointment</Menu.Item>
          </Menu.Dropdown>
        </Menu>
      </Group>
      <div className={classes.end}>
        <KiloLogo height='100%' width={50} />
      </div>
      <FiltersDrawer
        opened={isFilterDrawerOpen}
        searchFilters={searchFilters}
        initialSearchFiltersValue={initialSearchFiltersValue}
        setSearchFilters={setSearchFilters}
        closeFilters={filterDrawerHandlers.close}
      />
    </div>
  );
};

export default ScheduleHeader;
